var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('t-horizontal-panel',[_c('EdiPartsOverview',{attrs:{"slot":"left"},slot:"left"}),_c('EditEdipart')],1)}
var staticRenderFns = []

export { render, staticRenderFns }